export const state = () => ({
  theme: false,
})

export const mutations = {
  setTheme(state, v) {
    state.theme = v
  },
}
